/**
 * (車輌マスタメンテナンス 新規登録/詳細) 車輌外装キズチェック
 */

/* Import Modules */
import $ from "jquery";

/* Import Variables */
import {
  exteriorCheckRow,
  exteriorCheckCol,
} from "../../../../src/compositions/rentContract/carScratches/exterior";

/* Define Scripts */
/**
 * (車輌マスタメンテナンス 新規登録/詳細) 車輌外装キズ情報表示処理
 * @param exteriorCheck
 */
export const vehicleScratchesInfoInitialDisplayByExteriorCheck = (
  exteriorCheck
) => {
  const exteriorCheckArray = exteriorCheck.split(",");
  let index = 0;
  for (let i = 1; i <= exteriorCheckRow; i++) {
    for (let j = 1; j <= exteriorCheckCol; j++) {
      let elementId = "#exterior_" + i + "_" + j;
      $(elementId).text(exteriorCheckArray[index]);
      let elementModalId = "#m_exterior_" + i + "_" + j;
      $(elementModalId).text(exteriorCheckArray[index]);
      ++index;
    }
  }
};

/**
 * (車輌マスタメンテナンス 新規登録/詳細) キズ情報更新
 * @param row
 * @param col
 */
export const setExteriorCheckByCarCheckMasterModal = (
  row: number,
  col: number
) => {
  let elementId = "#m_exterior_" + row + "_" + col;
  $(elementId).text($("input[name='exterior-radio']:checked").val());
};

/**
 * (車輌マスタメンテナンス 新規登録/詳細) キズ情報反映
 */
export const setExteriorDataByCarCheckMasterModal = () => {
  let checkValue = "";
  for (let i = 1; i <= exteriorCheckRow; i++) {
    for (let j = 1; j <= exteriorCheckCol; j++) {
      /* ElementIdを取得 */
      let elementId = "#exterior_" + i + "_" + j;
      let elementModalId = "#m_exterior_" + i + "_" + j;
      /* カンマベースの入力値を取得 */
      checkValue += $(elementModalId).text();
      checkValue += ",";
      /* キズ情報 コピー処理 */
      $(elementId).text($(elementModalId).text());
    }
  }
  checkValue = checkValue.slice(0, -1);

  /* Move Exterior Value */
  $("#exterior_check").val(checkValue);

  /* Model Close */
  $("#exterior_close_button").trigger("click");
};

/**
 * グローバル関数を定義
 */
(window as any).vehicleScratchesInfoInitialDisplayByExteriorCheck =
  vehicleScratchesInfoInitialDisplayByExteriorCheck;
(window as any).setExteriorCheckByCarCheckMasterModal =
  setExteriorCheckByCarCheckMasterModal;
(window as any).setExteriorDataByCarCheckMasterModal =
  setExteriorDataByCarCheckMasterModal;
